(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["joy-heart-product-v2"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.initialized === 'true') return;
    const form = root.querySelector('.jh2-form');
    const variantSelect = root.querySelector('[data-variant-select]');
    const variants = JSON.parse(root.querySelector('[data-variants]').textContent);
    const messages = JSON.parse(root.querySelector('[data-messages]').textContent);
    const addonConfig = JSON.parse(root.querySelector('[data-addon-config]').textContent);
    if (!form || !variantSelect || !variants.length) return;
    const byId = new Map(variants.map(variant => [String(variant.id), variant]));
    const pairs = Array.from(root.querySelectorAll('[data-pair]'));
    const addon = root.querySelector('[data-addon]');
    const add = root.querySelector('[data-add]');
    const stickyAdd = root.querySelector('[data-sticky-add]');
    const sticky = root.querySelector('[data-sticky]');
    const stickyVariant = root.querySelector('[data-sticky-variant]');
    const stickyError = root.querySelector('[data-sticky-error]');
    const actions = root.querySelector('[data-primary-actions]');
    const error = root.querySelector('[data-error]');
    const singleDiscount = Number(root.dataset.discountOne) || 0;
    const orderDiscount = Number(addonConfig.discount) || 25;
    const discountCode = String(addonConfig.code || '').trim();
    const singleCode = String(addonConfig.singleCode || 'SAVE20').trim();
    const higherCode = String(addonConfig.higherCode || 'SAVE30').trim();
    const higherDiscount = Number(addonConfig.higherDiscount) || 30;
    const currency = root.dataset.currency || 'USD';
    let formatter;
    try { formatter = new Intl.NumberFormat(root.dataset.locale || 'en-US', { style: 'currency', currency }); }
    catch (_) { formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }); }
    const money = cents => formatter.format(cents / 100);
    const template = (text, values) => Object.entries(values).reduce((result, [key, value]) => result.replaceAll('[' + key + ']', String(value)), text);
    const percentText = percent => template(messages.percentOff, { percent });
    const wantsAddon = () => Boolean(addon && addon.checked && addonConfig.available);
    const discountedUnit = (price, percent) => price - Math.floor(price * percent / 100);
    const singleTotal = variant => discountedUnit(variant.price, singleDiscount);
    const pairTotal = variant => discountedUnit(variant.price, orderDiscount) + discountedUnit(Number(addonConfig.price), orderDiscount);
    let busy = false;
    let cartState = 'idle';
    let submittedVariant = '';
    let submittedAddon = false;

    const slides = Array.from(root.querySelectorAll('[data-slide]'));
    const thumbs = Array.from(root.querySelectorAll('[data-thumb]'));
    let mediaIndex = Math.max(0, slides.findIndex(slide => !slide.hidden));
    function showMedia(index) {
      if (!slides.length) return;
      mediaIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, position) => {
        slide.hidden = position !== mediaIndex;
        if (slide.hidden) slide.querySelectorAll('video').forEach(video => video.pause());
      });
      thumbs.forEach(thumb => thumb.setAttribute('aria-current', String(thumb.dataset.thumb === slides[mediaIndex].dataset.mediaId)));
      const counter = root.querySelector('[data-media-counter]');
      if (counter) counter.textContent = (mediaIndex + 1) + ' / ' + slides.length;
    }
    function sync(variantChanged = false) {
      const variant = byId.get(variantSelect.value);
      if (!variant) return;
      const chosen = wantsAddon();
      const locked = busy || cartState !== 'idle';
      const total = chosen ? pairTotal(variant) : singleTotal(variant);
      const estimated = template(messages.estimate, { price: money(total) });
      root.dataset.cartState = cartState;
      root.querySelector('[data-total]').textContent = chosen ? estimated : money(total);
      const original = root.querySelector('[data-original]');
      original.textContent = money(variant.price + (chosen ? Number(addonConfig.price) : 0));
      original.hidden = !chosen && singleDiscount <= 0;
      const saving = root.querySelector('[data-saving]');
      saving.textContent = chosen ? messages.selectedPairPrice : percentText(singleDiscount);
      saving.hidden = !chosen && singleDiscount <= 0;
      root.querySelector('[data-price-context]').textContent = chosen ? messages.pairContext : messages.singleContext;
      const selectedPair = pairs.find(button => button.dataset.pair === String(variant.id));
      root.querySelector('[data-selected-pair]').textContent = selectedPair ? selectedPair.dataset.pairLabel : variant.title;
      pairs.forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.pair === String(variant.id)));
        button.disabled = locked || !byId.get(button.dataset.pair).available;
      });
      if (addon) {
        addon.disabled = locked || !variant.available;
        root.querySelector('[data-addon-label]').textContent = chosen ? messages.flowerAdded : messages.addFlower;
        root.querySelector('[data-pair-total]').hidden = !chosen;
        root.querySelector('[data-pair-total-value]').textContent = estimated;
        root.querySelector('[data-offer-note]').hidden = !chosen;
      }
      const recovering = cartState === 'discount_pending';
      const viewCart = cartState === 'uncertain' || cartState === 'ready';
      const buttonText = busy ? (recovering ? messages.checkingDiscount : messages.adding) : recovering ? messages.retryDiscount : viewCart ? messages.viewCart : !variant.available ? messages.soldOut : chosen ? messages.addBoth : messages.add + ' · ' + money(total);
      add.textContent = buttonText;
      add.disabled = busy || (cartState === 'idle' && !variant.available);
      variantSelect.disabled = locked;
      if (stickyVariant) { stickyVariant.value = String(variant.id); stickyVariant.disabled = locked; }
      if (stickyAdd) {
        stickyAdd.disabled = add.disabled;
        stickyAdd.textContent = buttonText;
        root.querySelector('[data-sticky-context]').textContent = chosen ? messages.pairTotal + ' · ' + estimated : messages.packOne;
      }
      root.querySelectorAll('[data-cart-recovery]').forEach(link => { link.hidden = cartState === 'idle' || cartState === 'ready'; });
      if (variantChanged) {
        error.hidden = true;
        if (stickyError) stickyError.hidden = true;
        const selectedOption = variantSelect.options[variantSelect.selectedIndex];
        const target = selectedOption.dataset.variantMedia || (variant.featured_media && variant.featured_media.id);
        const position = slides.findIndex(slide => String(slide.dataset.mediaId) === String(target));
        if (position >= 0) showMedia(position);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantSelect.value);
        window.history.replaceState(window.history.state, '', url.toString());
      }
    }
    pairs.forEach(button => button.addEventListener('click', () => {
      if (busy || cartState !== 'idle') return;
      variantSelect.value = button.dataset.pair;
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }));
    variantSelect.addEventListener('change', () => sync(true));
    if (stickyVariant) stickyVariant.addEventListener('change', () => {
      variantSelect.value = stickyVariant.value;
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (addon) addon.addEventListener('change', () => sync());

    thumbs.forEach(thumb => thumb.addEventListener('click', () => showMedia(slides.findIndex(slide => slide.dataset.mediaId === thumb.dataset.thumb))));
    const prev = root.querySelector('[data-prev]');
    const next = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', () => showMedia(mediaIndex - 1));
    if (next) next.addEventListener('click', () => showMedia(mediaIndex + 1));
    const stage = root.querySelector('.jh2-stage');
    let startTouch = null;
    stage.addEventListener('touchstart', event => { const touch = event.changedTouches[0]; startTouch = { x: touch.clientX, y: touch.clientY }; }, { passive: true });
    stage.addEventListener('touchend', event => {
      if (!startTouch) return;
      const touch = event.changedTouches[0];
      const dx = touch.clientX - startTouch.x;
      const dy = touch.clientY - startTouch.y;
      if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy)) showMedia(mediaIndex + (dx < 0 ? 1 : -1));
      startTouch = null;
    }, { passive: true });
    function containsRequestedItems(cart) {
      const ids = [submittedVariant];
      if (submittedAddon) ids.push(String(addonConfig.id));
      return ids.every(id => (cart.items || []).some(item => String(item.variant_id || item.id) === id && Number(item.quantity) > 0));
    }
    const activeMerchandise = cart => (cart.items || []).filter(item => !item.gift_card && Number(item.quantity) > 0);
    const normalizeCode = value => String(value || '').trim().toUpperCase();
    function cartOffer(cart) {
      const quantity = activeMerchandise(cart).reduce((count, item) => count + Number(item.quantity), 0);
      if (quantity >= 3) return { code: higherCode, percent: higherDiscount };
      if (quantity >= 2) return { code: discountCode, percent: orderDiscount };
      return { code: singleCode, percent: singleDiscount };
    }
    async function applyCartOffer() {
      const snapshot = await fetch(root.dataset.cartJsonUrl, { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' });
      if (!snapshot.ok) throw new Error(messages.discountFailed);
      const before = await snapshot.json();
      if (!containsRequestedItems(before)) {
        cartState = 'uncertain';
        throw new Error(messages.itemsChanged);
      }
      const offer = cartOffer(before);
      const managedCodes = new Set([singleCode, discountCode, higherCode].map(normalizeCode));
      const codes = new Map();
      const preserveCode = value => {
        const code = String(value || '').trim();
        if (code && !managedCodes.has(normalizeCode(code))) codes.set(normalizeCode(code), code);
      };
      (before.discount_codes || []).forEach(discount => preserveCode(discount.code));
      (before.cart_level_discount_applications || []).forEach(discount => {
        if (discount.type === 'discount_code') preserveCode(discount.title);
      });
      (before.items || []).forEach(item => (item.line_level_discount_allocations || []).forEach(allocation => {
        const discount = allocation.discount_application || {};
        if (discount.type === 'discount_code') preserveCode(discount.title);
      }));
      codes.set(normalizeCode(offer.code), offer.code);
      const response = await fetch(root.dataset.updateUrl, {
        method: 'POST', credentials: 'same-origin',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: Array.from(codes.values()).join(',') })
      });
      if (!response.ok) throw new Error(messages.discountFailed);
      const cart = await response.json();
      if (!containsRequestedItems(cart)) {
        cartState = 'uncertain';
        throw new Error(messages.itemsChanged);
      }
      if (normalizeCode(cartOffer(cart).code) !== normalizeCode(offer.code)) throw new Error(messages.discountFailed);
      const matchesOffer = discount => Boolean(discount && discount.type === 'discount_code' && normalizeCode(discount.title) === normalizeCode(offer.code) && discount.value_type === 'percentage' && Number(discount.value) === offer.percent && discount.target_type === 'line_item');
      const orderApplications = cart.cart_level_discount_applications || [];
      const orderOffer = orderApplications.some(discount => matchesOffer(discount) && discount.target_selection === 'all' && Number(discount.total_allocated_amount) > 0);
      const paidItems = activeMerchandise(cart).filter(item => Number(item.original_line_price ?? item.original_price ?? item.price) > 0);
      const productOffer = paidItems.length > 0 && paidItems.every(item => (item.line_level_discount_allocations || []).some(allocation => Number(allocation.amount) > 0 && matchesOffer(allocation.discount_application)));
      const codeRejected = Array.isArray(cart.discount_codes) && !cart.discount_codes.some(discount => normalizeCode(discount.code) === normalizeCode(offer.code) && discount.applicable === true);
      if ((!orderOffer && !productOffer) || codeRejected) throw new Error(messages.discountFailed);
      const stackedProductDiscount = (cart.items || []).some(item => (item.line_level_discount_allocations || []).some(allocation => Number(allocation.amount) > 0 && !matchesOffer(allocation.discount_application)));
      const stackedOrderDiscount = orderApplications.some(discount => discount.target_type === 'line_item' && Number(discount.total_allocated_amount) > 0 && !matchesOffer(discount));
      if (stackedProductDiscount || stackedOrderDiscount) {
        cartState = 'uncertain';
        throw new Error(messages.offerMismatch);
      }
    }
    async function submitProduct(fromSticky = false) {
      const variant = byId.get(variantSelect.value);
      if (busy) return;
      if (cartState === 'uncertain' || cartState === 'ready') { window.location.assign(root.dataset.cartUrl); return; }
      if (!variant || !variant.available || !form.reportValidity()) return;
      const chosen = wantsAddon();
      busy = true;
      error.hidden = true;
      if (stickyError) stickyError.hidden = true;
      sync();
      let releaseTier;
      try {
        releaseTier = await window.JoyTierDiscounts?.acquire?.();
        if (cartState === 'idle') {
          submittedVariant = String(variant.id);
          submittedAddon = chosen;
          const items = [{ id: Number(variant.id), quantity: 1 }];
          if (chosen) items.push({ id: Number(addonConfig.id), quantity: 1 });
          let payload;
          try {
            const response = await fetch(root.dataset.addUrl, {
              method: 'POST', credentials: 'same-origin',
              headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
              body: JSON.stringify({ items })
            });
            payload = await response.json();
            if (!response.ok) throw new Error(typeof payload.description === 'string' ? payload.description : messages.error);
          } catch (failure) {
            cartState = 'uncertain';
            throw new Error(messages.cartUncertain);
          }
          if (!Array.isArray(payload.items) || !items.every(requested => payload.items.some(item => String(item.variant_id || item.id) === String(requested.id) && Number(item.quantity) >= 1))) {
            cartState = 'uncertain';
            throw new Error(messages.cartUncertain);
          }
          cartState = 'discount_pending';
          sync();
        }
        if (cartState === 'discount_pending') await applyCartOffer();
        cartState = 'ready';
        window.location.assign(root.dataset.cartUrl);
      } catch (failure) {
        const targetError = fromSticky && stickyError ? stickyError : error;
        targetError.textContent = cartState === 'discount_pending' ? messages.discountFailed : failure.message || messages.error;
        targetError.hidden = false;
        if (!fromSticky) targetError.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      } finally {
        try {
          if (typeof releaseTier === 'function') releaseTier();
        } finally {
          busy = false;
          sync();
        }
      }
    }
    form.addEventListener('submit', event => {
      event.preventDefault();
      event.stopImmediatePropagation();
      submitProduct(false);
    });
    if (stickyAdd) stickyAdd.addEventListener('click', () => submitProduct(true));

    if (sticky) {
      const updateSticky = () => { sticky.hidden = actions.getBoundingClientRect().bottom >= 0 || root.getBoundingClientRect().bottom < 0; };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(updateSticky, { threshold: [0, 1] });
        observer.observe(actions);
        observer.observe(root);
      }
      window.addEventListener('scroll', updateSticky, { passive: true });
      updateSticky();
      if ('ResizeObserver' in window) {
        const sizeObserver = new ResizeObserver(() => {
          const height = sticky.getBoundingClientRect().height;
          if (height > 0) root.style.setProperty('--jh-sticky-height', height + 'px');
        });
        sizeObserver.observe(sticky);
      }
    }
    const sectionLinks = Array.from(root.querySelectorAll('[data-section-link]'));
    function activateSectionLink(link) {
      sectionLinks.forEach(item => {
        if (item === link) item.setAttribute('aria-current', 'location');
        else item.removeAttribute('aria-current');
      });
    }
    sectionLinks.forEach(link => link.addEventListener('click', () => activateSectionLink(link)));
    const activateHashLink = () => {
      const link = sectionLinks.find(item => item.getAttribute('href') === window.location.hash);
      if (link) activateSectionLink(link);
    };
    window.addEventListener('hashchange', activateHashLink);
    activateHashLink();
    const reviews = root.querySelector('[data-reviews]');
    function enhanceReviews() {
      if (!reviews) return;
      const widget = reviews.querySelector('[data-average-rating][data-number-of-reviews]');
      if (widget) {
        const count = Number(widget.dataset.numberOfReviews);
        const rating = Number(widget.dataset.averageRating);
        if (count > 0 && rating > 0 && rating <= 5) {
          root.querySelector('[data-rating-value]').hidden = false;
          root.querySelector('[data-rating-fallback]').hidden = true;
          root.querySelector('[data-rating-number]').textContent = rating.toFixed(1);
          root.querySelector('[data-rating-count]').textContent = template(messages.reviewCount, { count });
        }
      }
      reviews.querySelectorAll('.jdgm-rev__pic-img[data-src]').forEach(image => {
        if (image.dataset.heartBound === 'true') return;
        image.dataset.heartBound = 'true';
        const finish = failed => { const link = image.closest('.jdgm-rev__pic-link'); if (link) { link.classList.remove('jdgm--loading'); link.classList.toggle('jh2-review-image-error', failed); } };
        image.addEventListener('load', () => finish(false), { once: true });
        image.addEventListener('error', () => finish(true), { once: true });
        image.loading = 'lazy';
        image.src = image.dataset.src;
        if (image.complete) finish(image.naturalWidth === 0);
      });
    }
    if (reviews) {
      const observer = new MutationObserver(enhanceReviews);
      observer.observe(reviews, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-average-rating', 'data-number-of-reviews'] });
      enhanceReviews();
    }
    root.dataset.initialized = 'true';
    root.classList.add('is-ready');
    root.querySelectorAll('[data-js-only]').forEach(element => { element.hidden = false; });
    showMedia(mediaIndex);
    sync();
  }
  document.querySelectorAll('[data-heart-section]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-heart-section]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["joysembly-kids-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const controller = new AbortController();
    const on = (element, type, action, options = {}) => element?.addEventListener(type, action, {...options, signal: controller.signal});
    const $ = selector => root.querySelector(selector);
    const $$ = selector => Array.from(root.querySelectorAll(selector));
    const form = $('.jk-form'), variant = $('[data-variant]'), quantity = $('[data-quantity]');
    const add = $('[data-add]'), sticky = $('[data-sticky]'), stickyAdd = $('[data-sticky-add]');
    const stickyVariant = $('[data-sticky-variant]'), stickyQuantity = $('[data-sticky-quantity]');
    const upsell = $('[data-upsell]'), upsellCheck = $('[data-upsell-check]'), upsellVariant = $('[data-upsell-variant]');
    const upsellSelected = () => upsellVariant?.options[upsellVariant.selectedIndex];
    const hasUpsell = () => Boolean(upsellCheck?.checked && upsellSelected()?.dataset.available === 'true');
    let moneyFormat;
    try { moneyFormat = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:root.dataset.currency || 'USD'}); }
    catch (_) { moneyFormat = new Intl.NumberFormat('en-US', {style:'currency', currency:'USD'}); }
    const formatMoney = cents => moneyFormat.format(cents / 100);
    const slides = $$('[data-slide]'), thumbs = $$('[data-thumb]');
    let mediaIndex = Math.max(0, slides.findIndex(slide => !slide.hidden));
    let busy = false, stickyFrame = 0, dayTimer;
    let cartState = 'idle', submittedIds = [], purchaseDestination = 'cart';
    const buyNow = $('[data-buy-now]');
    if (buyNow) buyNow.hidden = false;
    const discountedUnit = (price, percent) => price - Math.floor(price * percent / 100);
    const offerForQuantity = count => count >= 3 ? {code:'SAVE30',percent:30} : count >= 2 ? {code:'SAVE25',percent:25} : {code:'SAVE20',percent:20};
    const selected = () => variant.options[variant.selectedIndex];
    function showMedia(index) {
      if (!slides.length) return;
      mediaIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.hidden = i !== mediaIndex;
        if (slide.hidden) slide.querySelectorAll('video').forEach(video => video.pause());
        if (slide.hidden) slide.querySelectorAll('iframe').forEach(frame => {
          if (frame.hasAttribute('src')) { frame.dataset.pausedSrc = frame.getAttribute('src'); frame.removeAttribute('src'); }
        });
        else slide.querySelectorAll('iframe[data-paused-src]').forEach(frame => { frame.setAttribute('src', frame.dataset.pausedSrc); delete frame.dataset.pausedSrc; });
      });
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === mediaIndex)));
      if ($('[data-counter]')) $('[data-counter]').textContent = `${mediaIndex + 1} / ${slides.length}`;
    }
    on($('[data-prev]'), 'click', () => showMedia(mediaIndex - 1));
    on($('[data-next]'), 'click', () => showMedia(mediaIndex + 1));
    thumbs.forEach((thumb, i) => on(thumb, 'click', () => showMedia(i)));
    let touchStart;
    on($('[data-stage]'), 'touchstart', event => { touchStart = event.touches[0]; }, {passive:true});
    on($('[data-stage]'), 'touchend', event => {
      if (!touchStart || event.target.closest('video, iframe, model-viewer, button')) return;
      const end = event.changedTouches[0], dx = end.clientX - touchStart.clientX, dy = end.clientY - touchStart.clientY;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) showMedia(mediaIndex + (dx < 0 ? 1 : -1));
      touchStart = null;
    }, {passive:true});
    function syncPurchase(changeMedia = false) {
      const option = selected(), available = option?.dataset.available === 'true';
      const paired = hasUpsell(), count = Number(quantity.value || 1);
      const offer = offerForQuantity(count + (paired ? 1 : 0));
      const unitPrice = discountedUnit(Number(option?.dataset.price || 0), offer.percent);
      const displayedSubtotal = unitPrice * count + (paired ? discountedUnit(Number(upsellSelected()?.dataset.price || 0), offer.percent) : 0);
      root.dataset.previewCode = offer.code;
      $('[data-price]').textContent = option?.dataset['money' + offer.percent] || formatMoney(unitPrice);
      const compare = $('[data-compare]');
      compare.hidden = Number(option?.dataset.price || 0) === unitPrice;
      compare.textContent = option?.dataset.money || '';
      const discountBadge = $('[data-discount-badge]');
      discountBadge.hidden = compare.hidden;
      discountBadge.textContent = discountBadge.dataset.label.replace('__percent__', String(offer.percent));
      $('[data-per-item]').hidden = count === 1;
      if (stickyVariant) stickyVariant.value = variant.value;
      if (stickyQuantity) stickyQuantity.value = quantity.value;
      if ($('[data-sticky-price]')) $('[data-sticky-price]').textContent = formatMoney(displayedSubtotal);
      if ($('[data-sticky-upsell]')) $('[data-sticky-upsell]').hidden = !paired;
      const locked = busy || cartState !== 'idle';
      if (upsell) {
        upsell.dataset.selected = String(paired);
        const upsellOption = upsellSelected();
        $('[data-upsell-price]').textContent = paired ? upsellOption.dataset['money' + offer.percent] : upsellOption?.dataset.money || '';
        $('[data-upsell-compare]').hidden = !paired;
        $('[data-upsell-compare]').textContent = upsellOption?.dataset.money || '';
        upsellCheck.disabled = locked || upsellOption?.dataset.available !== 'true';
        upsellVariant.disabled = locked;
      }
      [add, stickyAdd].filter(Boolean).forEach(button => {
        button.disabled = busy || (cartState === 'idle' && !available);
        button.textContent = busy ? (cartState === 'discount_pending' ? root.dataset.checkingDiscount : root.dataset.loadingLabel)
          : cartState === 'discount_pending' ? root.dataset.retryDiscount
          : cartState !== 'idle' ? root.dataset.viewCart
          : available ? root.dataset.addLabel : root.dataset.soldLabel;
        if (button === add && available && !locked) button.textContent += ' · ' + formatMoney(displayedSubtotal);
      });
      if ($('[data-express]')) $('[data-express]').hidden = !available || cartState !== 'idle';
      if (buyNow) buyNow.disabled = locked || !available;
      [variant, quantity, stickyVariant, stickyQuantity].filter(Boolean).forEach(input => { input.disabled = locked; });
      if (changeMedia) {
        const index = slides.findIndex(slide => slide.dataset.mediaId === option?.dataset.mediaId);
        if (index >= 0) showMedia(index);
        const url = new URL(location.href); url.searchParams.set('variant', variant.value); history.replaceState(history.state, '', url);
      }
    }
    function syncUpsell() {
      const option = upsellSelected();
      if (!option) return;
      if (option.dataset.available !== 'true') upsellCheck.checked = false;
      $('[data-upsell-stock]').hidden = option.dataset.available === 'true';
      $$('[data-upsell-link]').forEach(link => { link.href = option.dataset.url; });
      let image = $('.jk-upsell-image img');
      if (option.dataset.image) {
        if (!image) {
          image = document.createElement('img'); image.width = 240; image.height = 240;
          image.alt = $('.jk-upsell-title').textContent; image.loading = 'lazy';
          $('.jk-upsell-image').replaceChildren(image);
        }
        image.removeAttribute('srcset'); image.removeAttribute('sizes'); image.src = option.dataset.image;
        image.hidden = false;
      } else if (image) { image.hidden = true; }
      syncPurchase();
    }
    on(upsellCheck, 'change', () => { syncPurchase(); updateSticky(); });
    on(upsellVariant, 'change', () => { syncUpsell(); updateSticky(); });
    if (upsell) upsell.hidden = false;
    on(variant, 'change', () => syncPurchase(true));
    on(quantity, 'change', () => syncPurchase());
    on(stickyVariant, 'change', () => { variant.value = stickyVariant.value; variant.dispatchEvent(new Event('change', {bubbles:true})); });
    on(stickyQuantity, 'change', () => { quantity.value = stickyQuantity.value; quantity.dispatchEvent(new Event('change', {bubbles:true})); });
    const activeMerchandise = cart => (cart.items || []).filter(item => !item.gift_card && Number(item.quantity) > 0);
    const normalizeCode = value => String(value || '').trim().toUpperCase();
    const cartOffer = cart => offerForQuantity(activeMerchandise(cart).reduce((count, item) => count + Number(item.quantity), 0));
    const containsRequestedItems = cart => submittedIds.every(id => (cart.items || []).some(item => String(item.variant_id || item.id) === id && Number(item.quantity) > 0));
    async function applyCartOffer() {
      const snapshot = await fetch(root.dataset.cartJsonUrl, {headers:{Accept:'application/json'}, credentials:'same-origin', cache:'no-store'});
      if (!snapshot.ok) throw new Error(root.dataset.discountFailed);
      const before = await snapshot.json();
      if (!containsRequestedItems(before)) { cartState = 'uncertain'; throw new Error(root.dataset.itemsChanged); }
      const offer = cartOffer(before);
      const managedCodes = new Set(['SAVE20', 'SAVE25', 'SAVE30']), codes = new Map();
      const preserveCode = value => {
        const code = String(value || '').trim();
        if (code && !managedCodes.has(normalizeCode(code))) codes.set(normalizeCode(code), code);
      };
      (before.discount_codes || []).forEach(discount => preserveCode(discount.code));
      (before.cart_level_discount_applications || []).forEach(discount => { if (discount.type === 'discount_code') preserveCode(discount.title); });
      (before.items || []).forEach(item => (item.line_level_discount_allocations || []).forEach(allocation => {
        if (allocation.discount_application?.type === 'discount_code') preserveCode(allocation.discount_application.title);
      }));
      codes.set(offer.code, offer.code);
      const response = await fetch(root.dataset.cartUpdateUrl, {
        method:'POST', credentials:'same-origin', headers:{Accept:'application/json', 'Content-Type':'application/json'},
        body:JSON.stringify({discount:Array.from(codes.values()).join(',')})
      });
      if (!response.ok) throw new Error(root.dataset.discountFailed);
      const cart = await response.json();
      if (!containsRequestedItems(cart)) { cartState = 'uncertain'; throw new Error(root.dataset.itemsChanged); }
      if (cartOffer(cart).code !== offer.code) throw new Error(root.dataset.discountFailed);
      const matchesOffer = discount => Boolean(discount && discount.type === 'discount_code' && normalizeCode(discount.title) === offer.code && discount.value_type === 'percentage' && Number(discount.value) === offer.percent && discount.target_type === 'line_item');
      const orderApplications = cart.cart_level_discount_applications || [];
      const orderOffer = orderApplications.some(discount => matchesOffer(discount) && discount.target_selection === 'all' && Number(discount.total_allocated_amount) > 0);
      const paidItems = activeMerchandise(cart).filter(item => Number(item.original_line_price ?? item.original_price ?? item.price) > 0);
      const productOffer = paidItems.length > 0 && paidItems.every(item => (item.line_level_discount_allocations || []).some(allocation => Number(allocation.amount) > 0 && matchesOffer(allocation.discount_application)));
      const codeRejected = Array.isArray(cart.discount_codes) && !cart.discount_codes.some(discount => normalizeCode(discount.code) === offer.code && discount.applicable === true);
      if ((!orderOffer && !productOffer) || codeRejected) throw new Error(root.dataset.discountFailed);
      const stackedProductDiscount = (cart.items || []).some(item => (item.line_level_discount_allocations || []).some(allocation => Number(allocation.amount) > 0 && !matchesOffer(allocation.discount_application)));
      const stackedOrderDiscount = orderApplications.some(discount => discount.target_type === 'line_item' && Number(discount.total_allocated_amount) > 0 && !matchesOffer(discount));
      if (stackedProductDiscount || stackedOrderDiscount) { cartState = 'uncertain'; throw new Error(root.dataset.offerMismatch); }
    }
    async function submit(fromSticky, destination = 'cart') {
      if (busy) return;
      if (cartState === 'uncertain' || cartState === 'ready') { location.assign(root.dataset.cartUrl); return; }
      if (cartState === 'idle' && (selected()?.dataset.available !== 'true' || !form.reportValidity())) return;
      let data;
      if (cartState === 'idle') {
        purchaseDestination = destination;
        submittedIds = [String(variant.value)];
        data = new FormData(form);
        data.delete('return_to');
        data.set('id', variant.value); data.set('quantity', quantity.value);
        if (hasUpsell()) {
          submittedIds.push(String(upsellVariant.value));
          data.delete('id'); data.delete('quantity');
          data.set('items[0][id]', variant.value); data.set('items[0][quantity]', quantity.value);
          for (const [key, value] of Array.from(data.entries())) {
            const property = key.match(/^properties\[(.+)\]$/);
            if (property) { data.delete(key); data.append(`items[0][properties][${property[1]}]`, value); }
          }
          if (data.has('selling_plan')) { data.set('items[0][selling_plan]', data.get('selling_plan')); data.delete('selling_plan'); }
          data.set('items[1][id]', upsellVariant.value); data.set('items[1][quantity]', '1');
        }
      }
      $$('[data-error], [data-sticky-error]').forEach(node => { node.hidden = true; node.textContent = ''; });
      $('[data-cart-recovery]').hidden = true;
      busy = true; syncPurchase();
      let releaseTier;
      try {
        // Coordinate with the existing optional site-wide quantity/discount script.
        releaseTier = await window.JoyTierDiscounts?.acquire?.();
        if (cartState === 'idle') {
          try {
            const response = await fetch(root.dataset.cartAddUrl + '.js', {method:'POST', body:data, credentials:'same-origin', headers:{Accept:'application/json'}});
            const result = await response.json();
            const added = Array.isArray(result.items) ? result.items : [result];
            if (!response.ok || !submittedIds.every(id => added.some(item => String(item.variant_id || item.id) === id && Number(item.quantity) > 0))) throw new Error(root.dataset.cartUncertain);
          } catch (_) {
            // A failed response can follow a partial add. Never blindly add again.
            cartState = 'uncertain'; throw new Error(root.dataset.cartUncertain);
          }
          cartState = 'discount_pending'; syncPurchase();
        }
        await applyCartOffer();
        cartState = 'ready';
        location.assign(purchaseDestination === 'checkout' ? root.dataset.checkoutUrl : root.dataset.cartUrl);
      } catch (error) {
        const message = fromSticky && $('[data-sticky-error]') ? $('[data-sticky-error]') : $('[data-error]');
        message.textContent = cartState === 'discount_pending' ? root.dataset.discountFailed : error.message || root.dataset.cartError;
        message.hidden = false; $('[data-cart-recovery]').hidden = false;
        if (!fromSticky) message.scrollIntoView({block:'nearest', behavior:'smooth'});
      } finally {
        try { if (typeof releaseTier === 'function') releaseTier(); }
        finally { busy = false; syncPurchase(); updateSticky(); }
      }
    }
    on(form, 'submit', event => {
      event.preventDefault(); event.stopImmediatePropagation();
      submit(false, event.submitter === buyNow ? 'checkout' : 'cart');
    }, {capture:true});
    on(stickyAdd, 'click', () => submit(true));

    const zipToggle = $('[data-zip-toggle]'), zipForm = $('[data-zip-form]'), zipInput = $('[data-zip-input]');
    const zipError = $('[data-zip-error-message]');
    const postalKey = 'joysembly-us-postal';
    let postal = '';
    const normalizePostal = value => {
      const compact = String(value || '').trim().replace(/\s/g, '');
      if (/^\d{9}$/.test(compact)) return compact.slice(0,5) + '-' + compact.slice(5);
      return /^\d{5}(-\d{4})?$/.test(compact) ? compact : '';
    };
    try { postal = normalizePostal(localStorage.getItem(postalKey)); } catch (_) {}
    function displayPostal() {
      if (postal) $('[data-postal]').textContent = postal;
      zipToggle.textContent = postal ? root.dataset.changeLabel : root.dataset.addZipLabel;
    }
    function closePostal() { zipForm.hidden = true; zipToggle.setAttribute('aria-expanded','false'); zipToggle.focus(); }
    zipToggle.hidden = false; displayPostal();
    on(zipToggle,'click',() => {
      if (!zipForm.hidden) { closePostal(); return; }
      zipForm.hidden = false; zipToggle.setAttribute('aria-expanded','true'); zipInput.value = postal;
      zipError.hidden = true; zipInput.removeAttribute('aria-invalid'); zipInput.focus();
    });
    on($('[data-zip-cancel]'),'click',closePostal);
    on(zipForm,'keydown',event => { if (event.key === 'Escape') { event.preventDefault(); closePostal(); } });
    on(zipForm,'submit',event => {
      event.preventDefault(); const next = normalizePostal(zipInput.value);
      if (!next) { zipError.textContent = root.dataset.zipError; zipError.hidden = false; zipInput.setAttribute('aria-invalid','true'); zipInput.focus(); return; }
      postal = next; try { localStorage.setItem(postalKey,postal); } catch (_) {}
      zipInput.removeAttribute('aria-invalid'); zipError.hidden = true; displayPostal(); closePostal(); updateDelivery();
    });
    function addBusinessDays(from, count) {
      const date = new Date(from.getFullYear(), from.getMonth(), from.getDate(), 12);
      for (let added = 0; added < count;) { date.setDate(date.getDate()+1); if (date.getDay() !== 0 && date.getDay() !== 6) added++; }
      return date;
    }
    function updateDelivery() {
      const today = new Date();
      const min = Math.max(1, Number(root.dataset.deliveryStart) || 10);
      const max = Math.max(min, Number(root.dataset.deliveryEnd) || 15);
      const start = addBusinessDays(today, min), end = addBusinessDays(today, max);
      const format = new Intl.DateTimeFormat('en-US', {weekday:'short',month:'short',day:'numeric',...(start.getFullYear() !== today.getFullYear() || end.getFullYear() !== today.getFullYear() ? {year:'numeric'} : {})});
      $('[data-arrival]').textContent = format.format(start) + ' – ' + format.format(end);
      clearTimeout(dayTimer);
      const midnight = new Date(today.getFullYear(),today.getMonth(),today.getDate()+1,0,0,1);
      dayTimer = setTimeout(updateDelivery,midnight.getTime()-today.getTime());
    }
    on(window,'pageshow',event => { if (event.persisted) busy = false; syncPurchase(); updateDelivery(); updateSticky(); });
    on(document,'visibilitychange',() => { if (!document.hidden) updateDelivery(); });
    updateDelivery();

    const tabs = $$('[data-tab]'), panels = $$('[data-panel]'), reviewPanel = $('[data-panel="reviews"]');
    function loadReviewImages() {
      if (!reviewPanel || reviewPanel.hidden) return;
      reviewPanel.querySelectorAll('.jdgm-rev__pic-img[data-src]').forEach(image => {
        if (image.dataset.jkLoaded) return;
        image.dataset.jkLoaded = 'true'; image.loading = 'eager';
        on(image,'load',() => image.closest('.jdgm-rev__pic-link')?.classList.remove('jdgm--loading'),{once:true});
        image.src = image.dataset.src;
      });
    }
    function activateTab(tab, focus = false) {
      if (!tab) return;
      tabs.forEach(button => { const active = button === tab; button.setAttribute('aria-selected',String(active)); button.tabIndex = active ? 0 : -1; });
      panels.forEach(panel => { panel.hidden = panel.dataset.panel !== tab.dataset.tab; });
      if (focus) tab.focus();
      if (tab.dataset.tab === 'reviews') { loadReviewImages(); window.dispatchEvent(new Event('resize')); }
    }
    panels.forEach(panel => { panel.setAttribute('role','tabpanel'); panel.setAttribute('aria-labelledby',`JoyKidsTab-${panel.dataset.panel}-${root.dataset.sectionId}`); panel.tabIndex = 0; });
    tabs.forEach((tab,index) => {
      on(tab,'click',() => activateTab(tab));
      on(tab,'keydown',event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); activateTab(tabs[next],true); }
      });
    });
    const openHash = () => {
      const panel = panels.find(item => '#' + item.id === location.hash);
      if (panel) activateTab(tabs.find(tab => tab.dataset.tab === panel.dataset.panel));
    };
    activateTab(tabs[0]); openHash(); $('[data-tablist]').hidden = false;
    on(window,'hashchange',openHash);
    on($('[data-open-reviews]'),'click',event => {
      event.preventDefault(); activateTab(tabs.find(tab => tab.dataset.tab === 'reviews'));
      $('[data-tablist]').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'});
    });
    const reviewObserver = reviewPanel ? new MutationObserver(loadReviewImages) : null;
    reviewObserver?.observe(reviewPanel,{childList:true,subtree:true});
    function updateSticky() {
      if (!sticky) return;
      sticky.hidden = add.getBoundingClientRect().bottom > 0;
      root.style.setProperty('--jk-reserve',sticky.hidden ? '0px' : `${sticky.offsetHeight + 16}px`);
    }
    function scheduleSticky() { if (!stickyFrame) stickyFrame = requestAnimationFrame(() => { stickyFrame = 0; updateSticky(); }); }
    on(document,'scroll',scheduleSticky,{passive:true,capture:true});
    on(window,'scroll',scheduleSticky,{passive:true});
    on(window,'resize',updateSticky);
    const visibilityObserver = sticky && 'IntersectionObserver' in window ? new IntersectionObserver(updateSticky) : null;
    visibilityObserver?.observe(add);
    const resizeObserver = sticky && 'ResizeObserver' in window ? new ResizeObserver(updateSticky) : null;
    if (resizeObserver) resizeObserver.observe(sticky);
    syncPurchase(); updateSticky();
    root.jkCleanup = () => { controller.abort(); clearTimeout(dayTimer); cancelAnimationFrame(stickyFrame); visibilityObserver?.disconnect(); resizeObserver?.disconnect(); reviewObserver?.disconnect(); delete root.dataset.ready; };
  }
  const start = () => document.querySelectorAll('[data-joy-kids]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-joy-kids]').forEach(init));
  document.addEventListener('shopify:section:unload',event => event.target.querySelectorAll('[data-joy-kids]').forEach(root => root.jkCleanup?.()));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
